export default {
  zendesk: {
    script: '//static.zdassets.com/ekr/snippet.js?key=d76cc45e-05d6-4cb7-b23d-5560135126f3',
  },
}
